module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "photoCell",
    staticClass: "photo-cell col-6 col-md-3 col-lg-2",
    style: ({
      height: _vm.photoCellHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "photo-cell-inner h-100 p-1"
  }, [_c('div', {
    staticClass: "d-flex flex-column h-100"
  }, [_c('div', {
    staticClass: "photo-no text-center"
  }, [_vm._v(_vm._s(_vm.photo.photo_no))]), _vm._v(" "), _c('div', {
    ref: "photoImageWrap",
    staticClass: "flex-grow-1",
    style: ({
      height: _vm.photoImageWrapHeight + 'px'
    })
  }, [_c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.smallThumbnailUrl),
      expression: "smallThumbnailUrl",
      arg: "background-image"
    }],
    staticClass: "photo-image point-cursor contain",
    on: {
      "click": _vm.showPhotoImageModal
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "relative-position text-center"
  }, [_c('span', {
    staticClass: "size-info d-inline-block py-1 px-1"
  }, [_vm._v(_vm._s(_vm.photoSizeMark))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning favorite-operation",
    style: ({
      visibility: _vm.visible
    }),
    on: {
      "click": _vm.donwloadImage
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_4_1'][5]"
    }
  })], 1), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search-plus image-zoom-btn",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.showPhotoImageModal
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c3defed!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/partials/MyPage/Order/Download/SnapHorizonPhoto.vue
// module id = 685
// module chunks = 0